import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import handleSearch from "../../utils/handleSearch";
import { DeleteModal, Modal } from "../Modal";
import NewAddress from "./NewAddress";
import { getStorage } from "../../utils/storage";
import toastMessage from "../../utils/toastMessage";
import axios from "axios";
import { fetchAddresses } from "../../queries/address/addressQuery";
import api from "../../utils/api";

let copyData = [];

class ListBusinessAddress extends React.Component {
  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 1,
    search_text: "",
    selected_data: {},
    error: {},
    csvData: [],
    delete_password: "",
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    this.getData(true);
  };

  getData = async (isLoading) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoading });

      const data = await fetchAddresses(defaultLanguage);

      this.setState({
        isLoading: false,
        data: data,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e.target.value,
      error,
    });
  }

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].location,
        key: "location",
      },
      {
        title: language[this.props.defaultLanguage].city,
        key: "city",
      },
      {
        title: language[this.props.defaultLanguage].town,
        key: "town",
      },
      {
        title: language[this.props.defaultLanguage].postal_address,
        key: "postalAddress",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      let { selected_data, user, data } = this.state;
      let { id } = this.props;

      data.splice(selected_data.dataIndex, 1);

      this.setState({ data: this.state.data });

      const options = {
        method: "PUT",
        url: `${api("profile")}/address`,
        data: {
          id,
        },
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };

      await axios(options);

      toastMessage(
        "success",
        language[this.props.defaultLanguage].delete_address_success
      );

      this.setState({ isDeleting: false });

      this.handleCloseModal("showDeleteModal");
      this.getData();
    } catch (error) {
      this.setState({
        isDeleting: false,
      });

      toastMessage(
        "error",
        language[this.props.defaultLanguage].delete_address_error
      );
    }
  };

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          isSearch={this.props.showSearch}
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          handleSearch={(e) =>
            handleSearch(this, {
              copyData,
              value: e.target.value,
            })
          }
          showAdd={this.props.showAdd}
          addButtonText={language[this.props.defaultLanguage].add_address}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            language[this.props.defaultLanguage].address
          )}
          actions={[
            {
              name: language[this.props.defaultLanguage].edit,
              onPress: (item) => this.handleShowModal("showModal", "", item),
            },
          ]}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <NewAddress
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selected_data}
          />
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state?.selected_data?._id}
            getData={this.getData.bind(this)}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ListBusinessAddress);
